import { useMutation, useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { useRequiredRole } from "@/hooks/useRequiredRole";
import { CardRequest } from "./-components/card-request";
import { LimitIncreaseRequest } from "./-components/limit-increase-request";
import { RejectRequestButton } from "./-components/reject-request-button";

export const Route = createFileRoute("/_authed/_org/requests/$id/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  const { trpc } = Route.useRouteContext();

  const { data: request } = useSuspenseQuery(
    trpc.request.get.queryOptions({
      requestId: id,
    }),
  );

  const { mutate: approveRequest, isPending: approvalPending } = useMutation(
    trpc.request.approve.mutationOptions({
      onError: async (err) => {
        toast.error(err.message, {
          position: "bottom-left",
        });
      },
      onSuccess: async (_data) => {
        toast.success("Request Approved", {
          position: "bottom-left",
        });
      },
    }),
  );

  const { admin } = useRequiredRole();

  return (
    <div className="flex grow flex-col justify-between">
      <div className="flex flex-col p-6 pt-0">
        {request.type === "card" && <CardRequest requestId={request.id} />}

        {request.type === "limit" && (
          <LimitIncreaseRequest requestId={request.id} />
        )}
      </div>

      {admin && request.status === "pending" && (
        <div className="mt-auto flex min-h-[64px] w-full flex-row items-center justify-between border-t p-6">
          <RejectRequestButton
            requestId={request.id}
            render={(rejectionPending) => (
              <Button
                className="font-semibold"
                size="default"
                variant="destructive"
                disabled={rejectionPending}
              >
                Reject
              </Button>
            )}
          />

          <Button
            className="font-semibold"
            size="default"
            onClick={() => approveRequest({ requestId: request.id })}
            disabled={approvalPending}
          >
            Approve
          </Button>
        </div>
      )}
    </div>
  );
}
